module.exports = __webpack_public_path__ + "static/media/phone.f2d8f2a7.png";